import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=27d5427c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d5427c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27d5427c')) {
      api.createRecord('27d5427c', component.options)
    } else {
      api.reload('27d5427c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=27d5427c&scoped=true&", function () {
      api.rerender('27d5427c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sdGy5OYha0fb/JS/comp/Accordion.vue"
export default component.exports